module.exports = __webpack_public_path__ + "static/media/playstore.aafe05f6.png";